import { Component, OnInit, Input, forwardRef, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { FormControl,NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

export function validateRequire(c,value,required) {
    if(!required){
        return null;
    }
    return (value && value.name) ? null : {validateRequire: true};
}

@Component({

    selector: 'aFormFile,[aFormFile]',
    templateUrl: './aFormFile.component.html',
    styleUrls: ['./aFormFile.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormFileComponent, multi: true },
        { provide: NG_VALIDATORS, useExisting: AFormFileComponent, multi: true },
    ]
})
export class AFormFileComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() icon;
    @Input() cClass;
    @Input() disabled;
    @ViewChild('file') file: ElementRef;
    @ViewChild('img') img: ElementRef;
    random;
    value;
    oldPath;
    formControl;
    display=false;
    temp;

    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }
    addFile() {
        this.file.nativeElement.click();
    }
    changeFile(event) {
        var ctrl = this;
        
        if (this.file.nativeElement.files.length > 0) {
            this.value = {};
            this.value.action = 'create';
            this.value.oldPath = this.oldPath;
            this.value.name = this.file.nativeElement.files[0]['name'];
            this.value.attachFile = this.random;
            this.value.file = this.id.split('.').join('\\.') + "\\.file";
            this._onChange(this.value);
            ctrl.img.nativeElement.src ='';
            var ext = /(\.|\/)(gif|jpe?g|png)$/i;
            var oFReader = new FileReader();
            if (this.file.nativeElement.files[0].name.match(ext)) {
                oFReader.readAsDataURL(this.file.nativeElement.files[0]);
            }
            oFReader.onload = function (oFREvent) {
                
                ctrl.img.nativeElement.src = oFREvent.target['result'];
            };
        } else {  
            this.removeFile();
        }
        
    }
    removeFile() {
        this.value = {};
        this.value.oldPath = this.oldPath;
        this.value.action = 'remove';
        this.file.nativeElement.value = '';
        this.img.nativeElement.src = '';
        this._onChange(this.value);
    }
    registerOnTouched() { }
    writeValue(value: any) {
        if (value && value.imgUrl) {
            this.oldPath = value.imgUrl;
            this.img.nativeElement.src = this.rootService.downloadPath + this.oldPath;
        }
        this.value = value;
    }
    validate(c: FormControl) {
        this.formControl = c;
        return validateRequire(c,this.value,this.required);
    }
    constructor(public rootService:RootService) {
        this.random = this.rootService.generateHexString(20);
    }

    ngOnInit() {
        this.file.nativeElement;
    }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormFile/aFormFile.component.ts